/**理想中心三栋 */
export const lxzx3 = [
  [104.062994,
    30.595779
  ],
  [104.063305,
    30.59577
  ],
  [104.063321,
    30.59552
  ],
  [104.063428,
    30.59552
  ],
  [104.063434,
    30.595377
  ],
  [104.063015,
    30.595363
  ],
  [104.062999,
    30.595774
  ],
  [104.062994,
    30.595779
  ]
]
export const lxzx2 = [
  [104.06249, 30.595659],
  [104.062758, 30.595765],
  [104.062736, 30.595456],
  [104.06265, 30.595359],
  [104.062366, 30.595368],
  [104.062361, 30.595589],
  [104.062495, 30.595576],
  [104.06249, 30.595659]
]